<template>
  <div class="searchbox">
    <div class="title"><b> {{style == 1 ? '证书查询':'Certificate Inquiry'}}</b></div>
    <div class="flex" v-if="style == 1">
      <iframe style="width: 100%;min-height: 300px;" src="https://3coa.cccap.org.cn/do/manage/customer_cert/list_cert/" frameborder="0"></iframe>
      <!-- <div class="flex_item">
        <div class="flex">
          <span>证书编号：</span>
          <div class="flex_item"><input type="text" placeholder="" v-model="query.cert_code"></div>
        </div>
      </div>
      <div class="flex_item">
        <div class="flex">
          <span>生产企业：</span>
          <div class="flex_item"><input type="text" placeholder="" v-model="query.factoryName"></div>
        </div>
      </div>
      <div class="flex_item">
        <div class="flex">
          <span>工厂代码：</span>
          <div class="flex_item"><input type="text" placeholder="" v-model="query.facCoding"></div>
        </div>
      </div>
      <div class="flex_item">
        <div class="flex">
          <span>证书状态：</span>
          <div class="flex_item">
            <el-select v-model="query.certStatus" >
              <el-option label="全部" value=""></el-option>
              <el-option label="有效" value="1"></el-option>
              <el-option label="暂停" value="2"></el-option>
              <el-option label="注销" value="3"></el-option>
              <el-option label="撤销" value="4"></el-option>
              <el-option label="失效" value="5"></el-option>
            </el-select>
          </div>
        </div>
      </div> -->
    </div>
    <div class="flex" v-else>
      <iframe style="width: 100%;min-height: 300px;" src="https://3coa.cccap.org.cn/do/manage/customer_cert/list_cert/?language=en" frameborder="0"></iframe>
      <!-- <div class="flex_item">
        <div class="flex">
          <span>Certificate number：</span>
          <div class="flex_item"><input type="text" placeholder="" v-model="query.cert_code"></div>
        </div>
      </div>
      <div class="flex_item">
        <div class="flex">
          <span>Factory name：</span>
          <div class="flex_item"><input type="text" placeholder="" v-model="query.factoryName"></div>
        </div>
      </div>
      <div class="flex_item">
        <div class="flex">
          <span>Factory code：</span>
          <div class="flex_item"><input type="text" placeholder="" v-model="query.facCoding"></div>
        </div>
      </div>
      <div class="flex_item">
        <div class="flex">
          <span>certificate status：</span>
          <div class="flex_item">
            <el-select v-model="query.certStatus" :placeholder="style == 1 ? '请选择':'Please select'">
              <el-option label="all" value=""></el-option>
              <el-option label="Effective" value="1"></el-option>
              <el-option label="Suspend" value="2"></el-option>
              <el-option label="Logout" value="3"></el-option>
              <el-option label="Revoke" value="4"></el-option>
              <el-option label="Expired" value="5"></el-option>
            </el-select>
          </div>
        </div>
      </div> -->
    </div>
    <!-- <button type="button" class="btn" @click="sumitQuery()">{{style == 1 ? '查询':'Search'}}</button> -->
    <!-- <SliderVerify v-if="show" @close="close" @ok='ok'/> -->
  </div>
</template>

<script>
import SliderVerify from './SliderVerify.vue';
export default {
  name: "certification",
  components: {
    SliderVerify
  },
  data(){
    return {
      years:[],
      show:false,
      query:{
        uuid:''
      },
      codeUrl:'',
      uuid:'',
      style:1
    }
  },
  mounted() {
    if(this.$store.state.stations.id != 1004){
      this.getCode()
    }
    this.style = process.env.VUE_APP_BASE_STYLE
  },
  methods:{
    ok(){
        this.$emit("queryClick",this.query)
        this.show = false;
    },
    close(val){
      this.show = val;
    },
    sumitQuery(){
         // 验证至少填写一个主要查询条件
        if(!this.query.cert_code && !this.query.factoryName && !this.query.facCoding) {
          this.$message.error('请至少填写证书编号、生产企业或工厂代码中的一个');
          return;
        }
        this.show = true;
    },
    async getCode(){
      let res = await this.$api.getCaptcha({});
      console.log(res)
      this.codeUrl = "data:image/gif;base64," + res.data.data.img;
      this.query.uuid = res.data.data.uuid
    }
  }
}
</script>

<style scoped>
.searchbox{
  position: relative;
}

</style>
